// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__adelaila_015d8e', '__adelaila_Fallback_015d8e'"},"className":"__className_015d8e","variable":"__variable_015d8e"};